var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temp-container"},[_vm._t("default"),(_vm.item.file && _vm.item.file.name)?_c('div',{staticClass:"fileName"},[_vm._v(_vm._s(_vm.item.file.name))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }